import { render, staticRenderFns } from "./AbnormalUsagePage.vue?vue&type=template&id=24ce10a0&scoped=true"
import script from "./AbnormalUsagePage.vue?vue&type=script&lang=js"
export * from "./AbnormalUsagePage.vue?vue&type=script&lang=js"
import style0 from "./AbnormalUsagePage.vue?vue&type=style&index=0&id=24ce10a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce10a0",
  null
  
)

export default component.exports